<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from "svelte/store";
    import { storeActu } from '../scripts/classes/actu';
    import BallsDecouvrir from '../components/BallsDecouvrir.svelte';
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';
    import PopUp from '../components/PopUp.svelte';

    let day: string;
	let monthLong: string;
	let monthShort: string;
	let year: string;
    const websiteUrl = new URL(window.location.href).href;
    let unique = {}; // every {} is unique, {} === {} evaluates to false
    let showPopup = false;

    onMount(async () => {
        extractDateInfos(get(storeActu).date);
        window.scrollTo(0,0);
	});

	function extractDateInfos(inDate: string) {
		const dateArray = inDate.split("-");
		year = dateArray[0];
		day = dateArray[2];
		const date = new Date(parseInt(year), parseInt(dateArray[1]) - 1, parseInt(day));  // 2009-11-10
		monthShort = date.toLocaleString('default', { month: 'short' });
		monthLong = date.toLocaleString('default', { month: 'long' });
		day = parseInt(day).toString();
	}

    function share() {
        navigator.clipboard.writeText(websiteUrl);
        reloadPopUp();
    }

    function reloadPopUp() {
        unique = {};
        showPopup = true;
    }

</script>
    
<style lang="scss">

    .actu {
        margin-bottom: 90px;
        &__title {
            width: 50%;
            overflow-x: hidden;
            overflow-y: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        &__intro {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            &__text {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                margin: 0 0 20px 0;
                &__published {
                    margin: 20px 0 0 0;
                    font-size: 12px;
                }
            }
            &__img {
                width: 100%;
                padding: 0 40px 0 40px;
                &__src {
                    object-fit: cover;
                    object-position: 50% 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &__content {
            display: block;
            align-items: flex-start;
            margin: 50px 0 50px 0;
            width: 80%;
            border: 1px solid $color_black;
            background-color: $color_white;
            font-family: 'Borna-Medium';
            padding: 20px 20px 20px 20px;
            &__twocols {
                columns: 1;
            }
            &__threecols {
                columns: 1;
            }
            & :global(strong) {
                font-family: "Borna-Bold";
            }
            & :global(a) {
                text-decoration: none;
                color: $color_black;
                &::before {
                    content: "↘";
                    padding: 0 4px 0 0;
                }
                &:hover {
                    text-decoration: underline;
                }
            }
            & :global(ul) {
                list-style-type: "-  ";
                margin-block-start: 0;
                margin-block-end: 0;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                padding-inline-start: 13px;
            }
            & :global(h1) {
                display: block;
                font-size: 23px;
                margin-block-start: 0em;
                margin-block-end: 0.67em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                font-weight: bold;
            }
            & :global(h3) {
                border: 1px solid $color_black;
                background-color: $color_grey;
                padding: 5px 10px 4px 10px;
                width: fit-content;
                font-size: 13px;
                font-family: "Borna-Bold";
                margin: 20px 0 5px 0;
            }
            & :global(iframe) {
                width: 100%;
            }
            & :global(img) {
                width: 100%;
                height: auto;
            }
        }

        &__share {
            margin: 20px 0 0 0;
            width: 30px;
            height: 30px;
            background-image: url('../assets/images/share.svg');
            &__copied {
                position: absolute;
                margin-top: -30px;
                margin-left: -100px;
            }
        }

    }

    @include large {
        .actu {
            &__title {
                width: auto; 
                overflow-x: auto;
                overflow-y: auto;
                display: inherit;
            }
            &__intro {
                width: 80%;
                max-width: 800px;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                align-self: center;
                padding: 0 0 0 0;
                &__text {
                    width: 70%;
                    align-items: flex-end;
                    &__text {
                        text-align: right;
                    }
                    &__published {
                        font-size: 1.1vw;
                    }
                }
                &__img {
                    z-index: 100;
                    width: 200px;
                    height: 150px;
                    padding: 0 0 0 20px;
                    margin: 0 -150px 0 0;
                    &__src {
                        object-fit: cover;
        				object-position: 50% 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            &__share {
                margin: 30px 0 0 15px;
                cursor: pointer;
                &:hover {
                    background-image: url('../assets/images/share_hover.svg');
                }
            }
            &__content {
                font-size: 1.2vw;
                width: 70%;
                max-width: 700px;
                padding: 70px 50px 70px 50px;
                margin: 20px 0 50px 0;
                &__twocols {
                    columns: 2;
                    column-gap: 30px;
                }
                &__threecols {
                    columns: 3;
                    column-gap: 30px;
                }
            }

        }
    }

    @include xlarge {
        .actu {
            &__intro {
                &__text {
                    &__published {
                        font-size: 15px;
                    }
                }
            }
            &__content {
                font-size: 16px;
            }
        }
    }

</style>

<div class="page">
    <div class="page__contener actu">
        <div class="page__title actu__title">{$storeActu.title}</div>
        <div class="page__intro actu__intro">
            <div class="actu__intro__text">
                <div class="actu__intro__text__text">{$storeActu.subtitle}</div>
                <div class="actu__intro__text__published">publié le {day}&nbsp;{monthLong}&nbsp;{year}</div>
                <div class="actu__share" on:click={() => share()} on:keydown={() => share()}>
                    <div class="actu__share__copied">
                        {#key unique}
                        <PopUp props={{isDisplayed: showPopup, message: "copié !"}} />
                        {/key}    
                    </div>    
                </div>
            </div>
            <div class="actu__intro__img">
                <img class="actu__intro__img__src" src="../assets/images/actus/{$storeActu.id}_{$storeActu.photo}" alt="actu">
            </div>
            
        </div>
        <div class="page__content actu__content" class:actu__content__twocols={$storeActu.nb_column == 2} class:actu__content__threecols={$storeActu.nb_column == 3}>
            {@html $storeActu.text}
        </div>
    </div>
    <NewsletterRegistration />
    <BallsDecouvrir />
</div>
